/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function (algolia) {
  'use strict';
  const swatchesKey = window.theme.newConfig.useNewSwatchesData ? "family" : "data";
  
  const firstImageKey = window.theme.newConfig.useNewFirstImage ? "newFirstImage" : "firstImage";
  const productTypesWhereComboImageIsPriority = ["Wall Fittings", "Pendant Shade", "Frames", "Genesis Fitting Kits"];
  const collectionsWithoutCombinations = window.theme.newConfig.collectionsWithoutCombinations.split(',')

  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100).replace('.00', '');
  };

  const applyPercentageDiscount = (price, discountPercentage) => {
    return price * (1 - discountPercentage / 100);
  }

  const applyTradeDiscount = (price) => {
    return applyPercentageDiscount(price, window.theme.trade.discount);
  }

  function formattedPriceWithComparison(price, compare_at_price = 0, product_type) {
    if (theme.trade.customer && product_type !== "Gift Cards") {

      var compareAt = parseFloat(compare_at_price);
      var mainPrice = parseFloat(price);
      const tradePrice = applyTradeDiscount(compareAt > mainPrice ? compareAt : mainPrice);

      const tradeCustomerPrice = tradePrice > mainPrice ? mainPrice : tradePrice;

      return ' <span class="ais-hit--price-striked"><span>' + formatPrice(price > compare_at_price ? price : compare_at_price ) + '</span></span> <span class="ais-hit--price--sale">' + formatPrice(tradeCustomerPrice) + '<span class="ais-hit--price--ex-vat">' + ' Trade Price' + '</span></span>';
    }

    const hasPriceComparison = Number(compare_at_price) && Number(compare_at_price) > Number(price);
    if (hasPriceComparison) {
      return ' <span class="ais-hit--price-striked"><span>' + formatPrice(compare_at_price) + '</span></span> <span class="ais-hit--price--sale">' + formatPrice(price) + '</span>';
    }

    return formatPrice(price);
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  const fullEscapedAttribute =(attribute) => {
    return new DOMParser()
      .parseFromString(attribute, 'text/html')
      .documentElement
      .textContent
      .replace(/(<([^>]+)>)/gi, "");
  }

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(text, render) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }

      const currencyCode = window.currencyCode;

      const market_pricing = this[`market_pricing_${currencyCode}`];

      const price = this.meta?.upsells?.galleryIncludedPrice ? Number.parseFloat(this.meta.upsells.galleryIncludedPrice.replace("$", "")) : market_pricing ? market_pricing.price : this.price;
      const compareAtPrice = this.meta?.upsells?.galleryIncludedCompareAtPrice && this.meta?.upsells?.galleryIncludedCompareAtPrice !== "null" ? Number.parseFloat(this.meta.upsells.galleryIncludedCompareAtPrice.replace("$", "")) : market_pricing ? market_pricing.compare_at_price : this.compare_at_price;

      return formattedPriceWithComparison(price, compareAtPrice, this.product_type);
    },
    priceProduct: function priceProduct() {
      
      return escapeHtml(JSON.stringify({
        handle: this.handle,
        productType: this.product_type || "",
        showFrom: false,
        variants: [{
          multiplier: Number.parseInt(this.meta?.combinations?.multiplier || "1") || 1,
          galleryUpsells: this.meta?.upsells?.galleries?.split("|") || []
        }]
      }));
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }

      var pre = ''
      var hideFrom = false;
      if (this.product_type == "Lamp Shade") {
        hideFrom = true
      }

      if (this.product_type === "Pendant Shade") {
        pre = theme.strings.from + ' '
      }

      const currencyCode = window.currencyCode;

      const market_pricing = this[`market_pricing_${currencyCode}`];

      const price = this.meta?.upsells?.galleryIncludedPrice ? Number.parseFloat(this.meta.upsells.galleryIncludedPrice.replace("$", "")) : market_pricing ? market_pricing.price : this.price;
      const compareAtPrice = this.meta?.upsells?.galleryIncludedCompareAtPrice && this.meta?.upsells?.galleryIncludedCompareAtPrice !== "null" ? Number.parseFloat(this.meta.upsells.galleryIncludedCompareAtPrice.replace("$", "")) : market_pricing ? market_pricing.compare_at_price : this.compare_at_price;

      return pre + formattedPriceWithComparison(price, compareAtPrice, this.product_type);
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;

      if (this.objectID == 'scroll-tile') {
        return (this.handle);
      } else {
        return ('/products/' + this.handle + (
          addVariantId
            ? '?variant=' + this.objectID
            : ''
        ));
      }
    },
    fullTitle: function fullTitle() {
      var res = this.title;

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = fullEscapedAttribute(this._highlightResult.title.value);
      }

      return res;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = '';

      if (this._highlightResult) {
        if (this._highlightResult.title && this._highlightResult.title.value) {
          res = fullEscapedAttribute(this._highlightResult.title.value);
        }
      }

      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (this._highlightResult.product_type && this._highlightResult.product_type.value) {
        return fullEscapedAttribute(this._highlightResult.product_type.value);
      } else {
        return '';
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return fullEscapedAttribute(this._highlightResult.vendor.value);
      } else {
        return '';
      }
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct
        ? this.product_image
        : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
    colourSwatch: function colourSwatch() {
      if (this.meta) {
        if (this.meta.swatches) {
          if (this.meta.swatches[swatchesKey]) {
            var id = this.id;
            var variantID = this.objectID;
            var swatches = [];
            var htmlOutput = '';
            var variants = JSON.parse(this.meta.swatches[swatchesKey]);
            var swatchCount = 0;
            var includedSwatches = [];
            if (variants.length > 0) {
              for (let v = 0; v < variants.length; v++) {
                if (variants[v].active == true && variants[v].available == true) {
                  if (variants[v].filters.filters_colour) {
                    var colour = variants[v].filters.filters_colour[0];
                  } else {
                    var colour = null
                  }
                  var handle = variants[v].handle
                  var url = '/products/' + variants[v].handle;
                  var current = false

                  if (variantID == variants[v].variant_id) {
                    current = true
                  }

                  if (colour && url) {
                    swatches.push({
                      url: url,
                      colour: colour,
                      id: id + '-' + colour + '-' + handle,
                      current: current,
                      index: v
                    })
                  }
                }
              }
            }

            if (swatches.length > 1) {
              var coloursSeen = []
              swatches.forEach(function (item, i) {
                if (!coloursSeen.includes(item.colour)) {
                  swatches.splice(i, 1);
                  swatches.unshift(item);
                  coloursSeen.push(item.colour)
                }
              });
              swatches.sort((a, b) => a.index - b.index);

              for (let i = 0; i < swatches.length; i++) {
                if (swatches[i].current && !includedSwatches.includes(swatches[i].id)) {
                  if (theme.swatches[swatches[i].colour]) {
                    var swatch = theme.swatches[swatches[i].colour]

                    if (swatch.indexOf('https://') >= 0) {
                      htmlOutput += '<a href="' + swatches[i].url + '" class="c-card__swatch js-card-swatch c-card__swatch--selected" style="background-image: url(' + swatch + ')" data-image-id="' + swatches[i].id + '"></a>';
                      swatchCount += 1;
                      includedSwatches.push(swatches[i].id)
                    } else {
                      if (swatch.toLowerCase().indexOf("fff") > -1 || swatch.toLowerCase().indexOf("fff") > -1) {
                        htmlOutput += '<a href="' + swatches[i].url + '" class="c-card__swatch c-card__swatch--border js-card-swatch c-card__swatch--selected" style="background-color: ' + swatch + '" data-image-id="' + swatches[i].id + '"></a>';
                        swatchCount += 1;
                        includedSwatches.push(swatches[i].id)
                      } else {
                        htmlOutput += '<a href="' + swatches[i].url + '" class="c-card__swatch js-card-swatch c-card__swatch--selected" style="background-color: ' + swatch + '" data-image-id="' + swatches[i].id + '"></a>';
                        swatchCount += 1;
                        includedSwatches.push(swatches[i].id)
                      }
                    }
                  } else {
                    if (swatches[i].colour.toLowerCase().indexOf("fff") > -1 || swatches[i].colour.toLowerCase().indexOf("fff") > -1) {
                      htmlOutput += '<a href="' + swatches[i].url + '" class="c-card__swatch c-card__swatch--border js-card-swatch c-card__swatch--selected" style="background-color: ' + swatches[i].colour + '" data-image-id="' + swatches[i].id + '"></a>';
                      swatchCount += 1;
                      includedSwatches.push(swatches[i].id)
                    } else {
                      htmlOutput += '<a href="' + swatches[i].url + '" class="c-card__swatch js-card-swatch c-card__swatch--selected" style="background-color: ' + swatches[i].colour + '" data-image-id="' + swatches[i].id + '"></a>';
                      swatchCount += 1;
                      includedSwatches.push(swatches[i].id)
                    }
                  }
                }
              }

              for (let i = 0; i < swatches.length; i++) {
                if (swatches[i].current == false && !includedSwatches.includes(swatches[i].id)) {
                  if (swatchCount > 3) {
                    htmlOutput += '<span class="c-card__swatch--more">+' + (
                      swatches.length - 4
                    ) + '</span>'
                    break
                  } else if (theme.swatches[swatches[i].colour]) {
                    var swatch = theme.swatches[swatches[i].colour]

                    if (swatch.indexOf('https://') >= 0) {
                      htmlOutput += '<a href="' + swatches[i].url + '" class="c-card__swatch js-card-swatch" style="background-image: url(' + swatch + ')" data-image-id="' + swatches[i].id + '"></a>';
                      swatchCount += 1;
                      includedSwatches.push(swatches[i].id)
                    } else {
                      if (swatch.toLowerCase().indexOf("fff") > -1 || swatch.toLowerCase().indexOf("fff") > -1) {
                        htmlOutput += '<a href="' + swatches[i].url + '" class="c-card__swatch c-card__swatch--border js-card-swatch" style="background-color: ' + swatch + '" data-image-id="' + swatches[i].id + '"></a>';
                        swatchCount += 1;
                        includedSwatches.push(swatches[i].id)
                      } else {
                        htmlOutput += '<a href="' + swatches[i].url + '" class="c-card__swatch js-card-swatch" style="background-color: ' + swatch + '" data-image-id="' + swatches[i].id + '"></a>';
                        swatchCount += 1;
                        includedSwatches.push(swatches[i].id)
                      }
                    }
                  } else {
                    if (swatches[i].colour.toLowerCase().indexOf("fff") > -1 || swatches[i].colour.toLowerCase().indexOf("fff") > -1) {
                      htmlOutput += '<a href="' + swatches[i].url + '" class="c-card__swatch c-card__swatch--border js-card-swatch" style="background-color: ' + swatches[i].colour + '" data-image-id="' + swatches[i].id + '"></a>';
                      swatchCount += 1;
                      includedSwatches.push(swatches[i].id)
                    } else {
                      htmlOutput += '<a href="' + swatches[i].url + '" class="c-card__swatch js-card-swatch" style="background-color: ' + swatches[i].colour + '" data-image-id="' + swatches[i].id + '"></a>';
                      swatchCount += 1;
                      includedSwatches.push(swatches[i].id)
                    }
                  }
                }
              }
            }

            return htmlOutput
          }
        }
      }
    },
    colourSwatchImages: function colourSwatchImages() {
      if (this.meta) {
        if (this.meta.swatches) {
          if (this.meta.swatches[swatchesKey]) {
            var id = this.id;
            var swatches = [];
            var htmlOutput = '';
            var variants = JSON.parse(this.meta.swatches[swatchesKey])
            if (variants.length > 0) {
              for (let v = 0; v < variants.length; v++) {
                if (variants[v].active == true && variants[v].available == true) {
                  if (variants[v].filters.filters_colour) {
                    var colour = variants[v].filters.filters_colour[0];
                  } else {
                    var colour = null
                  }
                  var image = '';
                  var handle = variants[v].handle
                  var hasOffImage = false
                  var offImage = null;
                  if (variants[v].images) {
                    for (let image = 0; image < variants[v].images.length; image++) {
                      if (variants[v].images[image].tags && variants[v].images[image].tags.includes('OFF')) {
                        hasOffImage = true
                        offImage = variants[v].images[image].url
                      }
                    }
                  }

                  if (this.product_type == 'Lamp Shade' && hasOffImage) {
                    image = 'https://res.cloudinary.com/' + window.theme.environment.cloudinary_container + '/image/fetch/t_preview/c_scale,w_600/f_jpg/' + offImage
                  } else {
                    if (variants[v].original_img_urls) {
                      if (variants[v].original_img_urls.length > 0) {
                        for (let image = 0; image < variants[v].original_img_urls.length; image++) {
                          if (image == '' && variants[v].original_img_urls[image].alt_tags.includes('PREVIEW')) {
                            image = variants[v].original_img_urls[image].src;
                          }
                        }

                        if (image === '') {
                          for (let image = 0; image < variants[v].original_img_urls.length; image++) {
                            if (variants[v].original_img_urls[image].alt_tags.includes('LISTING')) {
                              image = variants[v].original_img_urls[image].src;
                            } else if (variants[v].original_img_urls[image].alt_tags.includes('BASE')) {
                              image = variants[v].original_img_urls[image].src;
                            }
                          }
                          image = variants[v].original_img_urls[0].src;
                        }

                        if (image.includes('cdn.shopify.com')) {
                          image = image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + 'large' + '.$2');
                        }
                      }
                    }
                  }
                  if (image && colour && this.title !== variants[v].title) {
                    swatches.push({
                      image: image,
                      id: id + '-' + colour + '-' + handle,
                      index: v
                    })
                  }
                }
              }

              if (swatches.length) { // Limit the total output to a maximum of 3
                for (let i = 0; i < Math.min(swatches.length, 3); i++) {
                  htmlOutput += '<img data-src="' + swatches[i].image + '" data-image-id="' + swatches[i].id + '" class="c-card__media-image c-card__media-image--swatch-hover u-lazyload js-lazyload" width="325" height="325">'
                }
              }

              return htmlOutput
            }
          }
        }
      }
    },
    productBadge: function productBadge() {
      var isNew = this.collections?.includes(theme.newConfig.collectionHandles.new) || false;
      var isSale = false;
      var isCustom = false;
      var isPreorder = false;
      var isComingSoon = false;

      if (this.compare_at_price > this.price) {
        isSale = true;
      }

      // check preorder
      if (this.meta) {
        if (this.meta.global) {
          if (this.meta.global.productstatus) {
            if (this.meta.global.productstatus == 'PREORDER') {
              if (this.inventory_quantity > 0) {
                isPreorder = true
              }
            }
            if (this.meta.global.productstatus == 'COMINGSOON') {
              isComingSoon = true
            }
          }
        }
      }

      if (this.inventory_policy == 'continue' && this.inventory_quantity <= 0) {
        isPreorder = true
      }

      // check for custom label
      var customLabel = '';
      if (this.meta) {
        if (this.meta.product_label) {
          if (this.meta.product_label.label) {
            isCustom = true
            customLabel = JSON.parse(this.meta.product_label.label)[0].cloudinary_src + 'w_65'
          }
        }
      }

      var saleBadge = theme.productLabels.sale;
      var newBadge = theme.productLabels.new;

      var hideLabel = false;
      if (this.meta) {
        if (this.meta.product_label) {
          if (this.meta.product_label.hide_label) {
            hideLabel = true
          }
        }
      }

      var preorderBadge = theme.productLabels.preorder;
      var comingSoonBadge = theme.productLabels.comingSoon;
      const globalSaleLowerTierBadge = theme.productLabels.globalSaleLowerTier;
      const globalSaleUpperTierBadge = theme.productLabels.globalSaleUpperTier;

      if ((theme.enableGlobalSaleBadge && this.product_type !== "Gift Cards") && !isSale && !isComingSoon) {
        const cartTotalPrice = window.__CART__?.original_total_price || 0;
        const isGreaterThanThreshold = !!(cartTotalPrice + this.price * 100 > theme.secondTierDiscountThreshold);
        const globalSaleBadge = isGreaterThanThreshold ? globalSaleUpperTierBadge : globalSaleLowerTierBadge;
        return '<div class="c-card__badge"><div class="c-badge"><img data-src="' + globalSaleBadge.src + '" class="u-lazyload js-lazyload" width="' + globalSaleBadge.width + '" height="' + globalSaleBadge.height + '"></div></div>'
      }
      if (isCustom && !hideLabel) {
        return '<div class="c-card__badge"><div class="c-badge"><img data-src="' + customLabel + '" class="u-lazyload js-lazyload"></div></div>'
      }
      else if (isComingSoon && !hideLabel) {
        return '<div class="c-card__badge"><div class="c-badge c-badge--large"><img data-src="' + comingSoonBadge.src + '" class="u-lazyload js-lazyload" width="' + comingSoonBadge.width + '" height="' + comingSoonBadge.height + '"></div></div>'
      }
      else if (isPreorder && preorderBadge != 'w_120') {
        return '<div class="c-card__badge"><div class="c-badge c-badge--large"><img data-src="' + preorderBadge.src + '" class="u-lazyload js-lazyload" width="' + preorderBadge.width + '" height="' + preorderBadge.height + '"></div></div>'
      }
      else if (isSale && saleBadge != 'w_70' && !hideLabel) {
        return '<div class="c-card__badge"><div class="c-badge"><img data-src="' + saleBadge.src + '" class="u-lazyload js-lazyload" width="' + saleBadge.width + '" height="' + saleBadge.height + '"></div></div>'
      } else if (isNew && newBadge != 'w_70' && !hideLabel) {
        return '<div class="c-card__badge"><div class="c-badge"><img data-src="' + newBadge.src + '" class="u-lazyload js-lazyload" width="' + newBadge.width + '" height="' + newBadge.height + '"></div></div>'
      }
    },
    hoverImage: function hoverImage() {
      if (this.meta) {
        if (this.meta.images) {
          if (this.meta.images.hover_video) {
            var id = this.meta.images.hover_video;
            var iframe = '<iframe src="https://player.vimeo.com/video/' + id + '?loop=1&muted=1&controls=0" width="325" height="325" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>'

            return '<div class="c-card__media-image c-card__media-image--video c-card__media-image--hover js-vimeo-card-hover">' + iframe + '</div>'
          } else if (this.meta.images.hover_image) {
            var url = '';

            if ((this.meta.images.hover_image).includes('cloudinary_src')) {
              if (JSON.parse(this.meta.images.hover_image)[0].cloudinary_src) {
                url = JSON.parse(this.meta.images.hover_image)[0].cloudinary_src + 'w_600'
              }
            } else {
              url = JSON.parse(this.meta.images.hover_image)[0];
              if (typeof url !== "object" && url.includes('cdn.shopify.com')) {
                url = url.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + 'large' + '.$2');
              }
            }

            return '<img data-src="' + url + '" class="c-card__media-image c-card__media-image--hover u-lazyload js-lazyload" width="325" height="325">'
          }
        }
      }
    },
    wishlist: function wishlist() {
      if (this.id) {
        var hasOffImage = false
        var image = ''
        if (this.meta) {
          if (this.meta.combinations) {
            if (this.meta.combinations.image__light_mode) {
              hasOffImage = true
            }
          }
        }

        if (this.product_type == 'Lamp Shade' && hasOffImage) {
          image = 'https://res.cloudinary.com/' + window.theme.environment.cloudinary_container + '/image/fetch/t_preview/c_scale,w_600/f_jpg/' + JSON.parse(this.meta.combinations.image__light_mode)[0].original_src
        } else {
          var image = this._distinct
            ? this.product_image
            : this.image;

          if (!image) {
            image = 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
          }

          image = image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + 'large' + '.$2');
        }

        return '<button class="js-wishlist-add c-card__wishlist" data-product-image="' + image + '" data-product-type="' + this.product_type + '" data-product-title="' + this.title + '" data-product-price="' + this.price + '" data-product-url="/products/' + this.handle + '" data-product-id="' + this.id + '" data-variant-id="' + this.objectID + '"><i class="c-icon c-icon--heart-outline"></i></button>'
      }
    },
    mainProdImage: function mainProdImage() {
      var hasOffImage = false
      var hasImageOverride = false

      if (this.product_type === "Genesis Fitting Kit" && this.meta.genesisFittingKit?.collectionPageImageURL) {
        return this.meta.genesisFittingKit.collectionPageImageURL;
      }

      if (this.meta) {
        if (this.meta.combinations) {
          if (this.meta.combinations.image__light_mode) {
            hasOffImage = true
          }

          if (this.meta.combinations[firstImageKey] && !collectionsWithoutCombinations.includes(window.collectionType)) {
            hasImageOverride = true
          }
        }
      }

      if (hasImageOverride && productTypesWhereComboImageIsPriority.includes(this.product_type)) {
        if (firstImageKey === "newFirstImage" ) {
          return this.meta.combinations[firstImageKey].replace('/image/upload/', '/image/upload/w_600/')
        }

        return JSON.parse(this.meta.combinations[firstImageKey]).url.replace('/image/upload/', '/image/upload/w_600/')
      } else if (this.product_type == 'Lamp Shade' && hasOffImage) {
        return 'https://res.cloudinary.com/' + window.theme.environment.cloudinary_container + '/image/fetch/t_preview/c_scale,w_600/f_jpg/' + JSON.parse(this.meta.combinations.image__light_mode)[0].original_src
      } else {
        var image = this._distinct
          ? this.product_image
          : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_large.$2');
      }
    },

    trackUserFilterInteraction: function trackUserFilterInteraction(refinementList, query) {
      window.dataLayer.push({
        event: "filter_interaction",
        filterUsed: refinementList,
        algoliaSearchQuery: query,
      });
    }
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original'
  ].forEach(function (size) {
    algolia.helpers[size + 'Image'] = (function (_size) {
      return function () {
        var productType = this.product_type;


        var image = this._distinct
          ? this.product_image
          : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        if (productType === "Lamp Shade") {
          var meta = this.meta;
          if (meta && meta.combinations && meta.combinations.image__light_mode) {
            var transformation = "t_preview";
            var prefix = `https://res.cloudinary.com/${window.theme.environment.cloudinary_container
              }/image/fetch/`;
            var imageData = JSON.parse(meta.combinations.image__light_mode)
            var lightImage = imageData[0];
            return prefix + transformation + "/c_scale/" + lightImage.cloudinary_src
          }
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign({}, algolia.helpers, algolia.translation_helpers);
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--)
    helpersArray[i] = [
      helpersNames[i],
      helpers[helpersNames[i]]
    ];




  algolia.hoganHelpers = helpersArray.reduce(function (res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function () {
      return function (text) {
        var render = function (value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);